/**
 * Touch press language for controls. Fine pointers keep hover only.
 * Media queries are split because Chakra drops comma-separated `@media` inside `_active`.
 */
export const pressActive = {
  '@media (hover: none)': {
    transform: 'scale(0.97)',
    opacity: 0.88,
    transitionProperty: 'transform, opacity, background-color, border-color, color',
    transitionDuration: '0.08s',
    transitionTimingFunction: 'ease-out',
  },
  '@media (pointer: coarse)': {
    transform: 'scale(0.97)',
    opacity: 0.88,
    transitionProperty: 'transform, opacity, background-color, border-color, color',
    transitionDuration: '0.08s',
    transitionTimingFunction: 'ease-out',
  },
  '@media (prefers-reduced-motion: reduce)': {
    transform: 'none',
    opacity: 0.92,
  },
} as const;
